/* ==========================================================================
   OSERE — Rotador de la barra de anuncio

   Estaba incrustado en la sección. Vive en el grupo de la cabecera, así que
   viajaba en el HTML de LAS OCHO PÁGINAS. No dependía de Liquid para nada
   —ya buscaba por clase—, así que sale tal cual.
   ========================================================================== */

/* Rotador de la barra de anuncio. ~40 líneas, sin librerías.
       Custom element para que el theme editor lo vuelva a montar solo cuando
       la clienta edita la sección. */
    (function () {
      'use strict';
      if (customElements.get('os-anuncio-rotador')) return;

      customElements.define(
        'os-anuncio-rotador',
        class OsAnuncioRotador extends HTMLElement {
          connectedCallback() {
            this.piezas = Array.prototype.slice.call(this.querySelectorAll('[data-os-pieza]'));
            if (this.piezas.length < 2) return;

            var fija = this.querySelector('.os-anuncio__pieza--fija');
            this.indice = fija ? this.piezas.indexOf(fija) : 0;
            if (this.indice < 0) this.indice = 0;

            this.consulta = window.matchMedia('(prefers-reduced-motion: reduce)');
            this.evaluar = this.evaluar.bind(this);

            if (this.consulta.addEventListener) this.consulta.addEventListener('change', this.evaluar);
            document.addEventListener('visibilitychange', this.evaluar);
            this.evaluar();
          }

          disconnectedCallback() {
            this.detener();
            if (this.consulta && this.consulta.removeEventListener) {
              this.consulta.removeEventListener('change', this.evaluar);
            }
            document.removeEventListener('visibilitychange', this.evaluar);
          }

          /* Una sola puerta: movimiento reducido o pestaña oculta congelan la
             barra en la pieza fija. Nunca la dejan en blanco. */
          evaluar() {
            if (this.consulta.matches || document.hidden) this.detener();
            else this.arrancar();
          }

          arrancar() {
            if (this.temporizador) return;
            this.classList.add('os-anuncio__pista--vivo');
            this.pintar();
            var ms = parseInt(this.getAttribute('data-intervalo'), 10) || 5000;
            this.temporizador = setInterval(this.avanzar.bind(this), ms);
          }

          detener() {
            if (this.temporizador) {
              clearInterval(this.temporizador);
              this.temporizador = null;
            }
            this.classList.remove('os-anuncio__pista--vivo');
            this.piezas.forEach(function (pieza) {
              pieza.classList.remove('is-activa');
            });
          }

          avanzar() {
            this.indice = (this.indice + 1) % this.piezas.length;
            this.pintar();
          }

          pintar() {
            var actual = this.indice;
            this.piezas.forEach(function (pieza, n) {
              pieza.classList.toggle('is-activa', n === actual);
            });
          }
        }
      );
    })();
